<template>
  <div id="mobile-menu-wrapper">
    <v-btn icon @click="drawer = !drawer" id="side-toolbar-icon">
      <img src="~/assets/23/hamburger.png" alt="" />
    </v-btn>
    <v-navigation-drawer
      id="mobile-menu"
      v-model="drawer"
      :mini-variant="mini"
      absolute
      temporary
      :width="mobileWidth"
      disable-resize-watcher
      right
    >
      <v-list class="pa-1">
        <v-list-item v-if="mini" @click.stop="mini = !mini">
          <v-list-item-action>
            <v-icon>chevron_right</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item tag="div">
          <v-list-item-action id="inner-close">
            <v-btn icon @click="drawer = !drawer" aria-label="סגור תפריט">
              <img src="~/assets/23/xclose.svg" alt="" width="20px" />
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-list class="pt-0">
        <v-list-item
          v-for="(item, index) in navbarLinks"
          :key="index"
          class="text-right"
        >
          <v-list-item-content class="list-item-row">

            <v-btn
              v-if="item.innerPage"
              :to="index === 8 ? smartLink : item.link"
              target="_self"
              class="white--text"
              text
              @click.native="fireGtmEvent(item.value , index)"
            >
              <v-list-item-title :class="index === 4 ? 'no-cv-badge' : ''">
                <span v-if="index != 8">
                  {{ item.value | strippedContent }}
                </span>
                <span v-else>הסוכנת החכמה</span>
                <img src="/stamp-menu.png" v-if="index === 3" />
              </v-list-item-title>
            </v-btn>
            <v-btn
              v-else
              :href="item.link"
              target="_blank"
              class="white--text"
              text
              @click.native="fireGtmEvent(item.value)"
            >
              <v-list-item-title :class="index === 3 ? 'no-cv-badge' : ''">
                <span>
                  {{ item.value | strippedContent }}
                </span>
              </v-list-item-title>
            </v-btn>

          </v-list-item-content>
        </v-list-item>

        <v-list-item class="mt-12 white--text text-right">
          <v-list-item-content class="list-item-row">
            <nuxt-link to="/myJobs.aspx" class="white--text">
              <v-list-item-title>
                <v-icon class="icon-like white--text" />
                משרות שאהבתי
              </v-list-item-title>
            </nuxt-link>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content class="list-item-row">
            <a :href="adminUrl">
              <v-list-item-title>
                <v-icon class="icon-megaphone-7" />
                {{ userNavbar.value }}
              </v-list-item-title>
            </a>
          </v-list-item-content>
        </v-list-item>
        <v-list-item inactive class="white-text text-right">
          <v-list-item-content v-show="isLogged">
            <nuxt-link to="#" @click.native="logout()">
              <v-list-item-title>
                <v-icon color="primary lighten-1" class="icon-user" />
                יציאה
              </v-list-item-title>
            </nuxt-link>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';
import CurrentUser from '@/components/mixins/CurrentUser';
import gtm from '@/lib/gtm';

export default {
  mixins: [CurrentUser],
  data() {
    return {
      textAdmin: 'גיוס עובדים',
      mini: false,
      drawer: false,
      isOpen: false,
      mobileWidth: '260px',
      noCvNew: t('titles.noCvNewText'),
      navbarLinks: t('titles.topNavbar'),
      userNavbar: t('titles.userLoginMenu'),
      items: [
        {
          id: 1,
          name: 'Applications :',
          children: [
            { id: 2, name: 'Calendar : app' },
            { id: 3, name: 'Chrome : app' },
            { id: 4, name: 'Webstorm : app' }
          ]
        }
      ]
    };
  },

  computed: {
    adminUrl() {
      return process.env.adminUrl;
    },
    smartLink() {
      if (this.CurrentUser && this.NumberOfAgents) {
        return '/personal/smartalertsnotification/';
      } else {
        return '/smartalerts.aspx';
      }
    },

    jobsBasketSum() {
      return this.jobsBasket.size;
    }
  },
  methods: {
    fireGtmEvent(name) {
      gtm({
        name: 'main_bar',
        main_bar_name: name.replace('</br>', ' '),
        event: 'drushim_main_bar'
      });

      // gtm({
      //   category: 'הקלקה על משרות ללא קו"ח ',
      //   action: 'תפריט ראשי',
      //   event: 'משרות_ללא_קוח',
      // });

      // gtm({
      //   event_name: 'הקלקה על משרות ללא קו"ח ',
      //   place_click: 'תפריט ראשי',
      //   event: 'משרות_ללא_קוח_GA4',
      // });
    },
    async logout() {
      await this.$auth.logout();
    }
  }
};
</script>


<style lang="scss" scoped>
.no-cv-badge {
  position: relative;
  overflow: initial;
}
.no-cv-badge img {
  position: absolute;
  left: 0;
  top: -15px;
}
#mobile-menu {
  z-index: 150;
  overflow: visible;
  display: flex;
  flex-direction: column;
  background-color: $primary;
}
#mobile-menu .list-item-row {
  border-bottom: 1px solid #fff9;
}
#mobile-menu-wrapper {
  display: flex;
  align-self: center;
}
#mobile-menu-wrapper a,
* {
  color: #fff;
  text-align: right;
}
#mobile-menu-wrapper .v-list-item__content {
  padding: 5px 0;
  overflow: inherit;
}
#mobile-menu-wrapper .v-list-item {
  min-height: 35px;
}
.v-navigation-drawer--open #inner-close {
  display: inline-flex;
  max-height: 35px;
}

.v-overlay,
.v-overlay--active {
  z-index: 4000 !important;
}

.v-overlay--absolute {
  z-index: 4000 !important;
}

.v-navigation-drawer {
  background: $primary;
  color: #fff;
}

.v-list > div {
  color: #fff;
}

.v-list__tile__content {
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  padding: 3px 0;
  height: fit-content;
}

.v-list--dense .v-list__tile .v-icon {
  vertical-align: middle;
}

.icon-like:before {
  color: #fff;
  margin: 0 0 0 10px;
  font-size: 18px;
}

.icon-user:before {
  color: #fff;
  margin: 0 0 0 10px;
  font-size: 18px;
}

.icon-megaphone-7:before {
  color: #fff;
  margin: 0 0 0 10px;
  font-size: 18px;
}

.icon-group-21:before {
  color: #fff;
  margin: 0 0 0 10px;
  font-size: 18px;
}

.v-list__tile {
  height: auto !important;
}

#lang-list {
  font-size: 18px;
  color: #fff;
  text-align: right;
  padding-right: 90px;
  list-style: none;
}

#lang-list li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  line-height: 40px;
}

a,
.menu-item {
  width: 100%;
  font-size: 13px;
  text-decoration: none;
  color: #fff;
  display: block;
}

a br {
  display: inline-block;
}
#side-toolbar-icon {
  display: none;
}
@media screen and (max-width: 1280px) {
  #side-toolbar-icon {
    display: block;
  }
}
@media screen and (max-width: 1100px) {
}
@media screen and (max-width: 1450px) {
}
@media screen and (max-width: 968px) {
  #side-toolbar-icon {
    display: block;
  }
}
</style>
